const CONSTANTS = {
    ENDPOINT_SERVICE: {
        API: 1
    },
    ITEM_PER_PAGE: 10,
    AUDIT_ITEM_PER_PAGE: 20,
    USER_FUNCTIONS: {
        SYSTEM: 'system',
        USER: 'user',
        NEWS: 'news',
        DATA_LAYER: 'data-layer',
        DATABASE: 'database'
    },
    COMMON_NAV: [
        {
            url: '/dashboard',
            vi: 'Nước mặt',
            isDefault: true
        },
        {
            url: '/groundwater',
            vi: 'Nước dưới đất',
        },
        {
            url: '/help',
            vi: 'Trợ giúp'
        },
        {
            url: '/general-info',
            vi: 'Thông tin chung'
        },
        {
            url: '/tool',
            vi: 'Công cụ kỹ thuật'
        },
        {
            url: '/news',
            vi: 'Tin tức'
        },
        {
            url: '/feedback',
            vi: 'Liên hệ'
        }
    ],
    NEWS_STATUS: [
        { text: 'NHÁP', value: 'DRAFT' },
        { text: 'PHÁT HÀNH', value: 'PUBLISH' }
    ],
    NEWS_TYPE: [
        { text: 'TIN THƯỜNG', value: 'NORMAL' },
        { text: 'TIN CẢNH BÁO', value: 'WARNING' }
    ],
    BASE_MAP_OPTIONS: [
        // {
        //     key: 'region',
        //     label: 'Bản đồ hành chính',
        //     url: 'https://maps.vnpost.vn/api/tm/{z}/{x}/{y}@2x.png?apikey=674052d5aeb7658157d37306d8fc0bb42e7b69cff5e37440',
        // },
        {
            key: 'region',
            label: 'Bản đồ hành chính',
            url: 'https://gomaps.vnpt.vn/tiles/mapvnpt/v1/{z}/{x}/{y}.png?apiKey=ed001a40-978a-4993-8263-48f707ee6ce6',
        },
        {
            key: 'google-road',
            label: 'Google Map đường phố',
            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        },
        {
            key: 'google-sat',
            label: 'Google Map vệ tinh',
            url: 'https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        },
        {
            key: 'google-hybrid',
            label: 'Google Map vệ tinh kết hợp',
            url: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        },
        {
            key: 'google-terrain',
            label: 'Google Map địa hình',
            url: 'https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        }
    ],
};
export default CONSTANTS;
